export default __webpack_public_path__ + "static/media/tutorials.38b73026.svg";